import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = [
    "preset",
    "amount"
  ]

  connect() {
    this.syncPresetSelection()
  }

  selectPreset(event) {
    this.amountTarget.value = event.target.value
  }

  customAmountChanged() {
    this.syncPresetSelection()
  }

  syncPresetSelection() {
    const amount = parseFloat(this.amountTarget.value)

    this.presetTargets.forEach((preset) => {
      preset.checked = parseFloat(preset.value) === amount
    })
  }

  addToCart() {
    const amount = parseFloat(this.amountTarget.value || 0)

    this.element.dispatchEvent(
      new CustomEvent("donation-selector:add-to-cart", {
        bubbles: true,
        detail: {
          amount: amount
        }
      })
    )
  }
}